// src/Utils/controlaPermissao.js
// Centraliza leitura e normalização das permissões

const toFlag = (v) => String(v || "").trim().toUpperCase() === "S";

export const readPermissoes = (globalData) => {
  // prioridade: contexto.permissoes -> contexto.permissoes_grupo -> localStorage -> {}
  let origem =
    globalData?.permissoes ||
    globalData?.permissoes_grupo ||
    (() => {
      try {
        const raw = localStorage.getItem("permissoes_grupo");
        return raw ? JSON.parse(raw) : {};
      } catch {
        return {};
      }
    })();

  // alguns backends devolvem { permissoes: {...} }
  const perms = origem?.permissoes ?? origem ?? {};
  return perms || {};
};

// can("tipos_agendamento") => true/false
export const can = (globalData, permName) =>
  toFlag(readPermissoes(globalData)[permName]);

// flags já “prontas” com os mesmos nomes que você usa no Menu
export const getPermFlags = (globalData) => {
  const p = readPermissoes(globalData);
  return {
    permiteTiposAgendamento: toFlag(p.tipos_agendamento),
    permiteDocumentos: toFlag(p.documentos),
    permiteAgendamentos: toFlag(p.agendamentos),
    permiteConfiguracoesCampos: toFlag(p.configuracoes_campos),
    permiteConfiguracoesEmail: toFlag(p.configuracoes_email),

    constPermiteEmpresas: toFlag(p.empresas),
    constPermiteEntidades: toFlag(p.entidades),
    constPermiteFornecedores: toFlag(p.fornecedores),
    constPermiteFuncionarios: toFlag(p.funcionarios),
    constPermiteGerarAgendamentos: toFlag(p.gerar_agendamentos),
    constPermiteGruposUsuarios: toFlag(p.grupos_usuarios),
    constPermiteIndicesCorrecao: toFlag(p.indices_correcao),
    constPermiteTiposDocumento: toFlag(p.tipos_documento),
    constPermiteTiposFornecedor: toFlag(p.tipos_empresa),
    constPermiteUsuarios: toFlag(p.usuarios),
    constPermiteTiposdePagamento: toFlag(p.tipos_pagamento),
    constPermiteCamposCustomizados: toFlag(p.campos_customizados),

    // opcional: útil para debug
    _raw: p,
  };
};
